import {
  Companion_getInstance1dz3q9fvss53i as Companion_getInstance,
  Sessionjhz9dr2n4d55 as Session,
} from './subjectModels.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../serialization/SerializableProperty.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareSessionFields() {
  var tmp = Companion_getInstance().z2y(NothingSerializer(), NothingSerializer());
  properties(tmp, prepareSessionFields$lambda);
}
function Session__id$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(0);
}
function Session__id$_get_name_$ref_crdsbm() {
  return (p0) => p0.k20();
}
function Session__id$_get_serializer_$ref_5poz5n() {
  return (p0) => p0.j2j();
}
function Session__id$_get_annotations_$ref_iyl3e1() {
  return (p0) => p0.bz();
}
var Session__idClass;
function Session__id() {
  if (Session__idClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.a2z_1 = lazy(Session__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b2z_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.c2z_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(0));
        this.d2z_1 = Companion_getInstance_0().m2p();
        this.e2z_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.a2z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session__id$_get_name_$ref_crdsbm(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.g2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      u2z(receiver, value) {
        return receiver.v2z(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.u2z(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b2z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session__id$_get_serializer_$ref_5poz5n(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c2z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session__id$_get_annotations_$ref_iyl3e1(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -642392068;
      }
      equals(other) {
        return other instanceof Session__id();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session__id', VOID, VOID, [SerializableProperty()]);
    Session__idClass = $;
  }
  return Session__idClass;
}
function Session_secretHash$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(1);
}
function Session_secretHash$_get_name_$ref_lul4hg() {
  return (p0) => p0.k20();
}
function Session_secretHash$_get_serializer_$ref_jda6u3() {
  return (p0) => p0.j2j();
}
function Session_secretHash$_get_annotations_$ref_mqjjcv() {
  return (p0) => p0.bz();
}
var Session_secretHashClass;
function Session_secretHash() {
  if (Session_secretHashClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.w2z_1 = lazy(Session_secretHash$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x2z_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.y2z_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(1));
      }
      k20() {
        var tmp0 = this.w2z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_secretHash$_get_name_$ref_lul4hg(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.h2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      z2z(receiver, value) {
        return receiver.v2z(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.z2z(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x2z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_secretHash$_get_serializer_$ref_jda6u3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y2z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_secretHash$_get_annotations_$ref_mqjjcv(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1592257112;
      }
      equals(other) {
        return other instanceof Session_secretHash();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_secretHash', VOID, VOID, [SerializableProperty()]);
    Session_secretHashClass = $;
  }
  return Session_secretHashClass;
}
function Session_derivedFrom$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(2);
}
function Session_derivedFrom$_get_name_$ref_mvsr9() {
  return (p0) => p0.k20();
}
function Session_derivedFrom$_get_serializer_$ref_1i90fi() {
  return (p0) => p0.j2j();
}
function Session_derivedFrom$_get_annotations_$ref_um2aty() {
  return (p0) => p0.bz();
}
var Session_derivedFromClass;
function Session_derivedFrom() {
  if (Session_derivedFromClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.a30_1 = lazy(Session_derivedFrom$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b30_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.c30_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(2));
        this.d30_1 = null;
        this.e30_1 = 'null';
      }
      k20() {
        var tmp0 = this.a30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_derivedFrom$_get_name_$ref_mvsr9(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.i2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      f30(receiver, value) {
        return receiver.v2z(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.f30(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_derivedFrom$_get_serializer_$ref_1i90fi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_derivedFrom$_get_annotations_$ref_um2aty(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1589462033;
      }
      equals(other) {
        return other instanceof Session_derivedFrom();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_derivedFrom', VOID, VOID, [SerializableProperty()]);
    Session_derivedFromClass = $;
  }
  return Session_derivedFromClass;
}
function Session_label$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(3);
}
function Session_label$_get_name_$ref_40bb3c() {
  return (p0) => p0.k20();
}
function Session_label$_get_serializer_$ref_cqee9t() {
  return (p0) => p0.j2j();
}
function Session_label$_get_annotations_$ref_nh4y1v() {
  return (p0) => p0.bz();
}
var Session_labelClass;
function Session_label() {
  if (Session_labelClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.g30_1 = lazy(Session_label$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h30_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.i30_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(3));
        this.j30_1 = null;
        this.k30_1 = 'null';
      }
      k20() {
        var tmp0 = this.g30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_label$_get_name_$ref_40bb3c(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.j2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      l30(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.l30(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_label$_get_serializer_$ref_cqee9t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_label$_get_annotations_$ref_nh4y1v(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1755743742;
      }
      equals(other) {
        return other instanceof Session_label();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_label', VOID, VOID, [SerializableProperty()]);
    Session_labelClass = $;
  }
  return Session_labelClass;
}
function Session_subjectId$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(4);
}
function Session_subjectId$_get_name_$ref_4pafzf() {
  return (p0) => p0.k20();
}
function Session_subjectId$_get_serializer_$ref_nub35a() {
  return (p0) => p0.j2j();
}
function Session_subjectId$_get_annotations_$ref_coq39y() {
  return (p0) => p0.bz();
}
var Session_subjectIdClass;
function Session_subjectId() {
  if (Session_subjectIdClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.m30_1 = lazy(Session_subjectId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n30_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.o30_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(4));
      }
      k20() {
        var tmp0 = this.m30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_subjectId$_get_name_$ref_4pafzf(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.k2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      p30(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.p30(tmp, (!(value == null) ? isComparable(value) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_subjectId$_get_serializer_$ref_nub35a(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_subjectId$_get_annotations_$ref_coq39y(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1218984977;
      }
      equals(other) {
        return other instanceof Session_subjectId();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_subjectId', VOID, VOID, [SerializableProperty()]);
    Session_subjectIdClass = $;
  }
  return Session_subjectIdClass;
}
function Session_createdAt$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(5);
}
function Session_createdAt$_get_name_$ref_5t39of() {
  return (p0) => p0.k20();
}
function Session_createdAt$_get_serializer_$ref_6txlqy() {
  return (p0) => p0.j2j();
}
function Session_createdAt$_get_annotations_$ref_hf3i8m() {
  return (p0) => p0.bz();
}
var Session_createdAtClass;
function Session_createdAt() {
  if (Session_createdAtClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.q30_1 = lazy(Session_createdAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r30_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.s30_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(5));
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.t30_1 = get_default(Companion_instance).d1m();
        this.u30_1 = 'now()';
      }
      k20() {
        var tmp0 = this.q30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_createdAt$_get_name_$ref_5t39of(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.l2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      v30(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.v30(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_createdAt$_get_serializer_$ref_6txlqy(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_createdAt$_get_annotations_$ref_hf3i8m(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 724325531;
      }
      equals(other) {
        return other instanceof Session_createdAt();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_createdAt', VOID, VOID, [SerializableProperty()]);
    Session_createdAtClass = $;
  }
  return Session_createdAtClass;
}
function Session_lastUsed$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(6);
}
function Session_lastUsed$_get_name_$ref_6at193() {
  return (p0) => p0.k20();
}
function Session_lastUsed$_get_serializer_$ref_d00yxc() {
  return (p0) => p0.j2j();
}
function Session_lastUsed$_get_annotations_$ref_7256ms() {
  return (p0) => p0.bz();
}
var Session_lastUsedClass;
function Session_lastUsed() {
  if (Session_lastUsedClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.w30_1 = lazy(Session_lastUsed$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x30_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.y30_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(6));
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.z30_1 = get_default(Companion_instance).d1m();
        this.a31_1 = 'now()';
      }
      k20() {
        var tmp0 = this.w30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_lastUsed$_get_name_$ref_6at193(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.m2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      v30(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.v30(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_lastUsed$_get_serializer_$ref_d00yxc(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y30_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_lastUsed$_get_annotations_$ref_7256ms(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1358713187;
      }
      equals(other) {
        return other instanceof Session_lastUsed();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_lastUsed', VOID, VOID, [SerializableProperty()]);
    Session_lastUsedClass = $;
  }
  return Session_lastUsedClass;
}
function Session_expires$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(7);
}
function Session_expires$_get_name_$ref_2xxml4() {
  return (p0) => p0.k20();
}
function Session_expires$_get_serializer_$ref_xi76m9() {
  return (p0) => p0.j2j();
}
function Session_expires$_get_annotations_$ref_s4wuzn() {
  return (p0) => p0.bz();
}
var Session_expiresClass;
function Session_expires() {
  if (Session_expiresClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.b31_1 = lazy(Session_expires$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c31_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.d31_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(7));
        this.e31_1 = null;
        this.f31_1 = 'null';
      }
      k20() {
        var tmp0 = this.b31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_expires$_get_name_$ref_2xxml4(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.n2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      g31(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.g31(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_expires$_get_serializer_$ref_xi76m9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_expires$_get_annotations_$ref_s4wuzn(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1718049218;
      }
      equals(other) {
        return other instanceof Session_expires();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_expires', VOID, VOID, [SerializableProperty()]);
    Session_expiresClass = $;
  }
  return Session_expiresClass;
}
function Session_stale$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(8);
}
function Session_stale$_get_name_$ref_5dqd7h() {
  return (p0) => p0.k20();
}
function Session_stale$_get_serializer_$ref_svy8fw() {
  return (p0) => p0.j2j();
}
function Session_stale$_get_annotations_$ref_r1fjgo() {
  return (p0) => p0.bz();
}
var Session_staleClass;
function Session_stale() {
  if (Session_staleClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.h31_1 = lazy(Session_stale$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i31_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.j31_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(8));
        this.k31_1 = null;
        this.l31_1 = 'null';
      }
      k20() {
        var tmp0 = this.h31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_stale$_get_name_$ref_5dqd7h(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.o2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      g31(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.g31(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_stale$_get_serializer_$ref_svy8fw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_stale$_get_annotations_$ref_r1fjgo(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1537816067;
      }
      equals(other) {
        return other instanceof Session_stale();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_stale', VOID, VOID, [SerializableProperty()]);
    Session_staleClass = $;
  }
  return Session_staleClass;
}
function Session_terminated$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(9);
}
function Session_terminated$_get_name_$ref_uv1jc7() {
  return (p0) => p0.k20();
}
function Session_terminated$_get_serializer_$ref_bygv28() {
  return (p0) => p0.j2j();
}
function Session_terminated$_get_annotations_$ref_vmnjjw() {
  return (p0) => p0.bz();
}
var Session_terminatedClass;
function Session_terminated() {
  if (Session_terminatedClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.m31_1 = lazy(Session_terminated$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n31_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.o31_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(9));
        this.p31_1 = null;
        this.q31_1 = 'null';
      }
      k20() {
        var tmp0 = this.m31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_terminated$_get_name_$ref_uv1jc7(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.p2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      g31(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.g31(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_terminated$_get_serializer_$ref_bygv28(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_terminated$_get_annotations_$ref_vmnjjw(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1731055795;
      }
      equals(other) {
        return other instanceof Session_terminated();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_terminated', VOID, VOID, [SerializableProperty()]);
    Session_terminatedClass = $;
  }
  return Session_terminatedClass;
}
function Session_ips$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(10);
}
function Session_ips$_get_name_$ref_jxzrhs() {
  return (p0) => p0.k20();
}
function Session_ips$_get_serializer_$ref_bp2jw7() {
  return (p0) => p0.j2j();
}
function Session_ips$_get_annotations_$ref_njbxd1() {
  return (p0) => p0.bz();
}
var Session_ipsClass;
function Session_ips() {
  if (Session_ipsClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.r31_1 = lazy(Session_ips$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s31_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.t31_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(10));
        var tmp_2 = this;
        // Inline function 'kotlin.collections.setOf' call
        tmp_2.u31_1 = emptySet();
        this.v31_1 = 'setOf()';
      }
      k20() {
        var tmp0 = this.r31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_ips$_get_name_$ref_jxzrhs(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.q2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      w31(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.w31(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_ips$_get_serializer_$ref_bp2jw7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_ips$_get_annotations_$ref_njbxd1(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -642086966;
      }
      equals(other) {
        return other instanceof Session_ips();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_ips', VOID, VOID, [SerializableProperty()]);
    Session_ipsClass = $;
  }
  return Session_ipsClass;
}
function Session_userAgents$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(11);
}
function Session_userAgents$_get_name_$ref_bde0j3() {
  return (p0) => p0.k20();
}
function Session_userAgents$_get_serializer_$ref_4ehj4m() {
  return (p0) => p0.j2j();
}
function Session_userAgents$_get_annotations_$ref_aikfja() {
  return (p0) => p0.bz();
}
var Session_userAgentsClass;
function Session_userAgents() {
  if (Session_userAgentsClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.x31_1 = lazy(Session_userAgents$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y31_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[11];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.z31_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(11));
        var tmp_2 = this;
        // Inline function 'kotlin.collections.setOf' call
        tmp_2.a32_1 = emptySet();
        this.b32_1 = 'setOf()';
      }
      k20() {
        var tmp0 = this.x31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_userAgents$_get_name_$ref_bde0j3(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.r2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      w31(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.w31(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_userAgents$_get_serializer_$ref_4ehj4m(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z31_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_userAgents$_get_annotations_$ref_aikfja(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -2008178723;
      }
      equals(other) {
        return other instanceof Session_userAgents();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_userAgents', VOID, VOID, [SerializableProperty()]);
    Session_userAgentsClass = $;
  }
  return Session_userAgentsClass;
}
function Session_scopes$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(12);
}
function Session_scopes$_get_name_$ref_6p6qi3() {
  return (p0) => p0.k20();
}
function Session_scopes$_get_serializer_$ref_iyjwe4() {
  return (p0) => p0.j2j();
}
function Session_scopes$_get_annotations_$ref_zf6j40() {
  return (p0) => p0.bz();
}
var Session_scopesClass;
function Session_scopes() {
  if (Session_scopesClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.c32_1 = lazy(Session_scopes$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d32_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[12];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.e32_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(12));
      }
      k20() {
        var tmp0 = this.c32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_scopes$_get_name_$ref_6p6qi3(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.s2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      w31(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.w31(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_scopes$_get_serializer_$ref_iyjwe4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_scopes$_get_annotations_$ref_zf6j40(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1278615991;
      }
      equals(other) {
        return other instanceof Session_scopes();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_scopes', VOID, VOID, [SerializableProperty()]);
    Session_scopesClass = $;
  }
  return Session_scopesClass;
}
function Session_oauthClient$name$delegate$lambda() {
  return Companion_getInstance().z2y(NothingSerializer(), NothingSerializer()).az().v11(13);
}
function Session_oauthClient$_get_name_$ref_ppljbu() {
  return (p0) => p0.k20();
}
function Session_oauthClient$_get_serializer_$ref_j49nxv() {
  return (p0) => p0.j2j();
}
function Session_oauthClient$_get_annotations_$ref_8bq3u9() {
  return (p0) => p0.bz();
}
var Session_oauthClientClass;
function Session_oauthClient() {
  if (Session_oauthClientClass === VOID) {
    class $ {
      constructor(sUBJECT, iD) {
        var tmp = this;
        tmp.f32_1 = lazy(Session_oauthClient$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g32_1 = lazy(() => {
          var tmp = Companion_getInstance().z2y(sUBJECT, iD);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[13];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.h32_1 = lazy(() => Companion_getInstance().z2y(sUBJECT, iD).az().x11(13));
        this.i32_1 = null;
        this.j32_1 = 'null';
      }
      k20() {
        var tmp0 = this.f32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Session_oauthClient$_get_name_$ref_ppljbu(), null);
        return tmp0.f2();
      }
      f2z(receiver) {
        return receiver.t2z_1;
      }
      m2j(receiver) {
        return this.f2z(receiver instanceof Session() ? receiver : THROW_CCE());
      }
      l30(receiver, value) {
        return receiver.v2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Session() ? receiver : THROW_CCE();
        return this.l30(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Session_oauthClient$_get_serializer_$ref_j49nxv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h32_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Session_oauthClient$_get_annotations_$ref_8bq3u9(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 952689012;
      }
      equals(other) {
        return other instanceof Session_oauthClient();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Session_oauthClient', VOID, VOID, [SerializableProperty()]);
    Session_oauthClientClass = $;
  }
  return Session_oauthClientClass;
}
function prepareSessionFields$lambda(args) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new (Session__id())(args[0], args[1]), new (Session_secretHash())(args[0], args[1]), new (Session_derivedFrom())(args[0], args[1]), new (Session_label())(args[0], args[1]), new (Session_subjectId())(args[0], args[1]), new (Session_createdAt())(args[0], args[1]), new (Session_lastUsed())(args[0], args[1]), new (Session_expires())(args[0], args[1]), new (Session_stale())(args[0], args[1]), new (Session_terminated())(args[0], args[1]), new (Session_ips())(args[0], args[1]), new (Session_userAgents())(args[0], args[1]), new (Session_scopes())(args[0], args[1]), new (Session_oauthClient())(args[0], args[1])];
}
//region block: exports
export {
  prepareSessionFields as prepareSessionFields3a2t5uz9d2yuy,
};
//endregion

//# sourceMappingURL=SessionFields.mjs.map
